/** @jsx jsx */

import React, { useRef, useEffect, useLayoutEffect, useMemo } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import getAllInteractions from 'services/apiHelpers/getAllInteractions';
// import { getSavedInteractionsSeen } from 'services/scorm/scormService';
import getStore from 'services/getStore';
import { useSelector } from 'react-redux';

const store = getStore();
const { lPink, lGrey0, lGrey2 } = colors;

const ProgressBar = ({ color = lGrey0 }) => {
  const interactionsSeen = useSelector((state: any) => state.interactionsSeen);
  const width = 200;

  // const allSections: any = useMemo(() => {
  //   return getAllInteractions();
  // }, [getAllInteractions().length, store.getState().interactionsOpen.length]);

  // const unit = width / getAllInteractions().length; // allSections.length

  // const percent = (
  //   (interactionsSeen.length / getAllInteractions().length) *
  //   100
  // ).toFixed();

  const allInteractions = useMemo(() => {
    return getAllInteractions();
  }, []);

  const unit = width / allInteractions.length;
  const percent = (
    (interactionsSeen.length / allInteractions.length) *
    100
  ).toFixed();

  return (
    <div
      aria-valuenow={Number(percent)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-live="polite"
      css={css`
        position: relative;
        width: ${width}px;
        height: 10px;
        border: 1px solid ${color};
        border-radius: 5px;
        overflow: hidden;
      `}
    >
      <div
        css={css`
          position: absolute;
          left: 0px;
          top: 0px;
          width: ${unit * interactionsSeen.length}px;
          height: 10px;
          background: ${color};
          transition: width 0.2s;
        `}
      />

      <span className="sr-only">Progress: {percent}%</span>
    </div>
  );
};

export default ProgressBar;
